// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__20NzJ","header":"ReportDetails_header__feI6C","title":"ReportDetails_title__2PIyt","left":"ReportDetails_left__2UXxp"};